import { ICustomOccasion, repeatsOn } from './occasion-repeat'
import { toJalaali } from './jalaali'
import { toHijri } from './hijri'
import { IOccurrence } from './event-repeat'

export function occasionRange(o: ICustomOccasion, from: number, to: number): IOccurrence[] {
    const out: IOccurrence[] = []
    const first = new Date(from)
    for (let day = new Date(first.getFullYear(), first.getMonth(), first.getDate()); day.getTime() < to;
        day = new Date(day.getFullYear(), day.getMonth(), day.getDate() + 1)) {
        const gy = day.getFullYear(), gm = day.getMonth() + 1, gd = day.getDate()
        if (repeatsOn(o, { gy, gm, gd, ...toJalaali(gy, gm, gd), ...toHijri(gy, gm, gd),
            inMonth: true, isToday: false })) {
            out.push({ start: day.getTime(), end: new Date(gy, gm - 1, gd + 1).getTime() })
        }
    }
    return out
}
